import { GetServerSideProps } from "next";
import cares from "@/constants/care_detail.json";
import Head from "next/head";
import NotFoundPage from "pages/404";

import { FUNERAL_SIDO, FUNERAL_SIGUNGU } from "goi_common";
import { CareDetailContainer } from "@/containers/CareContainer";

const EXCLUDE_CARE_IDS = [12981];

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { id } = params as { id?: string };

  if (EXCLUDE_CARE_IDS.includes(Number(id))) {
    return {
      props: {
        defaultCare: null,
        hasError: true,
      },
    };
  }

  const careArray = cares as Array<any>;
  const targetCare = careArray.find((care) => care.id === Number(id));
  const sidoKR = FUNERAL_SIDO.get(Number(targetCare?.sido)) || "";
  const sigunguKR =
    FUNERAL_SIGUNGU.get(Number(targetCare?.sido))?.get(
      Number(targetCare?.sigungu)
    ) || "";

  const name = targetCare?.companyname || "";
  const description = `${sigunguKR} 요양병원, ${name} 시설 정보, 의료 인력 정보, 후기`;

  return {
    props: {
      defaultCare: targetCare,
      hasError: !targetCare,
      pageDescription: description,
      pageKeywords: `${sigunguKR} 요양병원, ${sidoKR} 요양병원, ${sidoKR} 병원, ${sigunguKR} 병원, ${sidoKR} 요양, ${sigunguKR} 요양, ${name} 시설, ${name} 의료 인력, ${name} 후기, 요양등급, 요양, 재활요양병원, 치매요양병원, 암요양병원, 재활병원`,
      pageOgTitle: `${sidoKR} ${sigunguKR} 요양병원, ${name} 정보 - [우리가 찾던 장례전문가, 고이]`,
      pageOgDescription: description,
    },
  };
};

interface CarePageProps {
  defaultCare: any;
  hasError: boolean;
  pageOgTitle: string;
}

function CareId({ defaultCare, hasError, pageOgTitle }: CarePageProps) {
  if (hasError) return <NotFoundPage />;

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>

        <link
          rel="canonical"
          href={`https://www.goifuneral.co.kr/care/${defaultCare.id}/`}
          key="canonical"
        />
      </Head>
      <CareDetailContainer care={defaultCare} />
    </>
  );
}

export default CareId;
